import React from "react";
import {
  Box,
  Paper,
  Typography,
  useTheme,
  Container,
  alpha,
} from "@mui/material";
import Logo from "../components/Logo";
import LoginForm from "../forms/LoginForm";

const LoginPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
        }}
      />

      <Container
        maxWidth="sm"
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={24}
          sx={{
            width: "100%",
            maxWidth: 450,
            p: { xs: 3, sm: 5 },
            borderRadius: theme.appRadius.xl,
            bgcolor:
              theme.palette.mode === "dark"
                ? alpha(theme.palette.background.paper, 0.8)
                : "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            textAlign: "center",
          }}
        >
          {/* --- LOGO SECTION --- */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                p: 1,
                borderRadius: theme.appRadius?.sm || 1,
                color: "white",
                display: "flex",
              }}
            >
              <Logo size="md" />
            </Box>
          </Box>

          {/* --- HEADINGS --- */}
          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
            Welcome Back
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 4 }}>
            Sign in to access your dashboard
          </Typography>

          {/* --- FORM SECTION --- */}
          <LoginForm />
        </Paper>
      </Container>
    </Box>
  );
};

export default LoginPage;
